import React, { useMemo } from 'react';
import { clsx } from 'clsx';

import Image from '@/src/shared/components/Image';
import { Quote } from './quote';
import { Stars } from './starts';
import styles from './richard-silver-testimonial.module.scss';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

type Props = {
  variant?: 'default' | 'testimonial-page' | 'row-profile';
  classes?: {
    container?: string;
    content?: string;
    quoteUp?: string;
    quoteDown?: string;
  };
};

export function RichardSilverTestimonial({
  classes,
  variant = 'default',
}: Props) {
  const { container, content, quoteUp, quoteDown } = classes || {};
  const isMdDown = useIsMobile('(max-width:768px)');

  const isForTestimonialPage = useMemo(
    () => variant === 'testimonial-page',
    [variant]
  );

  return (
    <div
      className={clsx(
        styles.container,
        container,
        styles[`variant-${variant}`]
      )}
    >
      <div className={styles.wrapper}>
        {!isForTestimonialPage && (
          <Quote
            direction="up"
            className={clsx(styles.quoteUp, {
              [quoteDown]: quoteUp,
            })}
          />
        )}
        <div
          className={clsx(styles.content, {
            [content]: content,
          })}
        >
          <div className={styles.profileWrapper}>
            <div className={styles.infoWrapper}>
              <div className={styles.imageWrapper}>
                <Image
                  src="/images/rechard-silver-testimonial/rechard-silver.jpg"
                  fill
                  objectFit="cover"
                  alt=""
                />
              </div>
              <div className={styles.namesWrapper}>
                <p
                  className={clsx(styles.name, {
                    [styles.testimonialPage]: isForTestimonialPage,
                  })}
                >
                  Richard Silver
                </p>
                {isForTestimonialPage ? (
                  <>
                    <p className={clsx(styles.role, styles.testimonialPage)}>
                      Senior Global Real Estate Advisor at Sotheby&apos;s
                      International Realty Canada{' '}
                      {isMdDown ? '' : '- Sales Representative'}
                    </p>
                    {!isMdDown && (
                      <p className={clsx(styles.role, styles.testimonialPage)}>
                        & Senior Vice President, Sales ABR, ePRO, CIPS, Senior
                        Global Real Estate Advisor
                      </p>
                    )}
                  </>
                ) : (
                  <>
                    <p className={styles.role}>
                      Sales Representative & Senior Vice President, Sales ABR,
                      ePRO, CIPS, Senior Global Real Estate Advisor
                    </p>
                  </>
                )}
              </div>
            </div>
            {isForTestimonialPage && !isMdDown && <Stars />}
          </div>

          <div className={styles.descriptionWrapper}>
            {isForTestimonialPage && (
              <Quote
                className={styles.descriptionQuoteUp}
                direction="up"
                narrow
              />
            )}
            <p
              className={clsx(styles.description, {
                [styles.testimonialPage]: isForTestimonialPage,
              })}
            >
              Roomvu is an excellent platform. It brings you great visibility
              and shows you to be a “subject matter expert” in your field and
              location. An excellent choice!
            </p>
            {isForTestimonialPage && (
              <Quote
                className={styles.descriptionQuoteDown}
                direction="down"
                narrow
              />
            )}
          </div>

          {isForTestimonialPage && isMdDown && <Stars />}
        </div>

        {!isForTestimonialPage && (
          <Quote
            direction="down"
            className={clsx(styles.quoteDown, {
              [quoteDown]: quoteDown,
            })}
          />
        )}
      </div>
    </div>
  );
}
